<template>
  <div class="mt-2">
    <h4>{{ label }}</h4>
    <v-layout v-if="!force">
      <v-flex offset-xs2 xs10>
        <v-radio-group v-model="isDateRangeActive" :mandatory="false">
          <v-radio :label="notUselabel" :value="false"></v-radio>
          <v-radio :label="uselabel" :value="true"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-slide-y-transition>
      <v-layout wrap align-center justify-start v-show="isDateRangeActive">
        <v-flex xs5 offset-xs2 style="max-width:200px;">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="120px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="startDate"
              no-title
              scrollable
              @input="startMenu = false"
            />
          </v-menu>
        </v-flex>
        <v-flex xs1 style="text-align: center;">
          〜
        </v-flex>
        <v-flex xs5 style="max-width:200px;">
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="120px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="endDate"
              no-title
              scrollable
              @input="endMenu = false"
            />
          </v-menu>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '使用可能期間',
    },
    uselabel: {
      type: String,
      default: '期間を指定する',
    },
    notUselabel: {
      type: String,
      default: '期間を指定しない',
    },
    force: {
      type: Boolean,
      default: false,
    },
    defaultUseDateRange: {
      type: Boolean,
      default: false,
    },
    start: {
      type: String,
      default: '',
    },
    end: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // datepicker表示制御用
      startMenu: false,
      endMenu: false,
      useDateRange: undefined,
    }
  },
  computed: {
    isDateRangeActive: {
      get() {
        if (this.force) {
          return true
        }
        if (this.useDateRange == null) {
          return this.defaultUseDateRange
        }
        return this.useDateRange
      },
      set(value) {
        this.useDateRange = value
        const result = {
          useDateRange: value,
          startDate: this.startDate,
          endDate: this.endDate,
        }
        this.$emit('change', result)
      },
    },
    startDate: {
      get() {
        return this.start
      },
      set(value) {
        const result = {
          useDateRange: true,
          startDate: value,
          endDate: this.endDate,
        }
        this.$emit('change', result)
      },
    },
    endDate: {
      get() {
        return this.end
      },
      set(value) {
        const result = {
          useDateRange: true,
          startDate: this.startDate,
          endDate: value,
        }
        this.$emit('change', result)
      },
    },
  },
}
</script>
